import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { axiosInstance } from "../axiosConfig";
import {
  PageLayout,
  RowEndLayout,
  BackgroundLayout,
  ColumnLayout,
  RowStartLayout,
  TextField,
  DatePickerField,
  ItemText,
  TableItemText,
  TableDataText,
  FilledButton,
  OutlinedButton,
  VerticalGap,
  TableDataButton,
  TextLink,
  TablePageButton,
} from "../component";
import { mainTableItems } from "../assets/data";
import { ReactComponent as DeleteIcon } from "../assets/delete.svg";

const MainScreen = () => {
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [totalPage, setTotalPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [tableData, setTableData] = useState([]);

  const onSearch = () => {
    try {
      axiosInstance
        .get(`${process.env.REACT_APP_BASE_URL}/project/totalPage`, {
          headers: {
            Authorization: `${localStorage.getItem("accessToken")}`,
          },
          params: {
            search: search,
            startDate: startDate,
            endDate: endDate,
          },
        })
        .then((res) => {
          setTotalPage(res.data.totalPage);
        });
      axiosInstance
        .get(`${process.env.REACT_APP_BASE_URL}/project/list`, {
          headers: {
            Authorization: `${localStorage.getItem("accessToken")}`,
          },
          params: {
            page: currentPage,
            search: search,
            startDate: startDate,
            endDate: endDate,
          },
        })
        .then((res) => {
          setTableData(res.data);
        });
    } catch (error) {
      console.error("프로젝트 리스트 오류:", error);
    }
  };

  const onReset = () => {
    setSearch("");
    setStartDate("");
    setEndDate("");
    onSearch();
    window.location.reload();
  };

  useEffect(() => {
    onSearch();
  }, [currentPage, totalPage]);

  const mainTableTimeItems = [
    {
      date: "오늘",
      click: () => {
        setStartDate(new Date().toISOString().slice(0, 10));
        setEndDate(new Date().toISOString().slice(0, 10));
      },
    },
    {
      date: "1주일",
      click: () => {
        const today = new Date();
        const lastWeek = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - 7
        );
        setStartDate(lastWeek.toISOString().slice(0, 10));
        setEndDate(today.toISOString().slice(0, 10));
      },
    },
    {
      date: "1개월",
      click: () => {
        const today = new Date();
        const lastMonth = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          today.getDate()
        );
        setStartDate(lastMonth.toISOString().slice(0, 10));
        setEndDate(today.toISOString().slice(0, 10));
      },
    },
    {
      date: "3개월",
      click: () => {
        const today = new Date();
        const lastMonth = new Date(
          today.getFullYear(),
          today.getMonth() - 3,
          today.getDate()
        );
        setStartDate(lastMonth.toISOString().slice(0, 10));
        setEndDate(today.toISOString().slice(0, 10));
      },
    },
  ];

  return (
    <PageLayout>
      <BackgroundLayout>
        <ColumnLayout>
          <RowStartLayout>
            <ItemText style={{ width: "90px" }}>검색</ItemText>
            <TextField
              placeholder="Job code, 현장 이름, 프로젝트 이름"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          </RowStartLayout>
          <RowStartLayout>
            <ItemText style={{ width: "90px" }}>공사 시작일</ItemText>
            <DatePickerField
              type="date"
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
              }}
            />
            -
            <DatePickerField
              type="date"
              value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value);
              }}
            />
            {mainTableTimeItems.map((item, index) => (
              <SearchItemButton onClick={item.click}>
                {item.date}
              </SearchItemButton>
            ))}
          </RowStartLayout>
        </ColumnLayout>
        <RowEndLayout style={{ height: "86px" }}>
          <FilledButton
            type="text"
            style={{ height: "100%", width: "50px" }}
            onClick={onSearch}
          >
            검색
          </FilledButton>
          <OutlinedButton
            style={{ height: "100%", width: "50px" }}
            onClick={onReset}
          >
            초기화
          </OutlinedButton>
        </RowEndLayout>
      </BackgroundLayout>
      <VerticalGap height="30px" />
      <RowEndLayout>
        <TextLink to="/add-project">+ 새 프로젝트 등록</TextLink>
      </RowEndLayout>
      <DataTable items={mainTableItems} data={tableData} />
      <VerticalGap height="30px" />
      <TablePageButton
        totalPage={totalPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </PageLayout>
  );
};

const DataTable = ({ items, data }) => {
  const handleDelete = (id, name) => {
    if (!window.confirm(`${name}를 삭제하시겠습니까?`)) {
      return;
    }
    try {
      axiosInstance
        .delete(`${process.env.REACT_APP_BASE_URL}/project/delete`, {
          headers: {
            Authorization: `${localStorage.getItem("accessToken")}`,
          },
          data: {
            id,
          },
        })
        .then(() => {
          window.location.reload();
        });
    } catch (error) {
      console.error("프로젝트 삭제 오류:", error);
      alert("프로젝트 삭제에 실패했습니다.");
    }
  };
  return (
    <TableLayout>
      {Object.keys(items).map((item, index) => (
        <TableItemText>{items[item]}</TableItemText>
      ))}

      {data.map((item, index) => (
        <>
          <TableDataText
            style={{
              justifyContent: "center",
              backgroundColor: "var(--color-background)",
            }}
          >
            {item.index}
          </TableDataText>
          <TableDataText style={{ justifyContent: "center" }}>
            {item.startDate ? item.startDate.slice(0, 10) : ""}
          </TableDataText>
          <TableDataText>{item.jobCode}</TableDataText>
          <TableDataText>{item.fieldName}</TableDataText>
          <TableDataText>{item.projectName}</TableDataText>
          <TableDataText style={{ justifyContent: "center" }}>
            <TableDataButton to={`/file/${item.id}`}>
              <span className="blue">관리</span>
            </TableDataButton>
          </TableDataText>
          <TableDataText style={{ justifyContent: "center" }}>
            <TableDataButton
              onClick={() => handleDelete(item.id, item.projectName)}
            >
              <DeleteIcon style={{ width: "20px" }} />
            </TableDataButton>
          </TableDataText>
        </>
      ))}
    </TableLayout>
  );
};

const TableLayout = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 4fr 6fr 9fr 9fr 4fr 1fr;
  justify-content: center;
  align-items: center;
  background-color: var(--color-background);
  border-top: 1px solid var(--color-gray);

  & > div {
    border-right: 1px solid var(--color-gray);
    border-bottom: 1px solid var(--color-gray);
  }

  & > div:nth-child(7n + 1) {
    border-left: 1px solid var(--color-gray);
  }

  & > div:nth-child(7n) {
    border-right: 1px solid var(--color-gray);
  }
`;

const SearchItemButton = styled(OutlinedButton)`
  width: 100px;
`;

export default MainScreen;
